import React from 'react';

import parse from 'html-react-parser';

import './style.sass';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const ServiceItem = ({ serviceItem: { img, icon, title, text, isReversed } }) => {
    let reverseMod = '';

    if (isReversed) {
        reverseMod = 'krdv-service-item--reversed';
    }

    return (
        <ScrollAnimation
            animateIn="fadeIn"
            offset={50}
            delay={100}
            animateOnce={true}
            duration={1}
            className={`krdv-service-item ${reverseMod}`}
        >
            <div className="krdv-service-item__img">
                <img src={img} alt="" loading="lazy" />
            </div>
            <div className="krdv-service-item__info">
                <div className="krdv-service-item__icon">
                    <img src={icon} alt="" loading="lazy" />
                </div>
                <CommonSmallTitle className="krdv-service-item__title">
                    {parse(title)}
                </CommonSmallTitle>
                <CommonSmallText className="krdv-service-item__text">{parse(text)}</CommonSmallText>
            </div>
        </ScrollAnimation>
    );
};

export default ServiceItem;
